import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoadingController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-reportes-productividad-agentes',
  templateUrl: './reportes-productividad-agentes.component.html',
  styleUrls: ['./reportes-productividad-agentes.component.scss'],
})
export class ReportesProductividadAgentesComponent implements OnInit {

  idAdmin: string;
  vista: number;
  fechaInicial: any;
  fechaFinal: any;
  loading: any;
  agentes: any;
  arrAgentes: any;
  classUser: any;
  totalFiltro: number;
  banderaNum: any;
  inicio: any;
  fin: any;
  nombreAgente: string;

  canal: any;
  canales: any;
  canalInicial: any;

  constructor(
    private storage: Storage,
    private serviceWa: WhatsappService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private formatdate: DatePipe
  ) {
    this.canales = [];
    this.fechaFinal = new FormControl('');
    this.fechaInicial = new FormControl('');
    this.nombreAgente = '';
  }

  ngOnInit() {
    this.vista = 0;
    this.agentes = [];
    this.arrAgentes = [];
    setTimeout(() => {
      this.getCanal();
    }, 500);
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
      // console.log(this.canales, 'canales ');
      this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
      this.idAdmin = this.canalInicial.canale.idAdmin_sec;
      this.classUser = this.canalInicial;
    this.getToday();
    // console.log(this.canal.url_back, 'url de back desde storage');
  }


  // consulta(val, num) {
  //   this.presentLoading('Cargando Reporte de efectividad...');
  //   let query = `admin=${this.idAdmin}`;
  //   if(val === 1) {
  //     const feIn = new Date(this.fechaInicial.value);
  //     const feFin = new Date(this.fechaFinal.value);
  //     feIn.setHours(0, 0, 0);
  //     feFin.setHours(23, 59, 59);
  //     // console.log(feIn);
  //     // console.log(feFin);
  //     query = `admin=${this.idAdmin}&inicio=${feIn}&fin=${feFin}`;
  //   }
  //   // console.log(query);
  //   this.serviceWa.getReporteEfectividad(query, this.classUser.id, this.classUser.rol,
  //     this.classUser.token).subscribe(
  //     (res: any)=>{
  //     // console.log(res);
  //     this.loading.dismiss();

  //       const {status, message} = res;
  //       if(status ==='success'){
  //        const {agentes} = res;
  //        this.agentes = agentes;
  //        console.log(this.agentes);
  //        this.formatTable(this.agentes);
  //        this.presentToast('Datos encontrados!', 'success');
  //        this.vista = 1;
  //       }
  //       else{
  //        this.presentToast('No se encontrarón conversaciones', 'danger');
  //       }
  //   },
  //   erro => {
  //     console.log(erro);
  //     this.loading.dismiss();
  //   });

  // }

  formatTable(agentes) {
    this.arrAgentes = agentes.map((agente) => {
      if(this.agentes.length > 0) {

      return {
        Nombre: `${agente.nombre} ${agente.apellido}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Total de conversaciones': agente.totalChats,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Promedio de conversación': agente.promedio,
      };
    }
    });
    this.descargar();
  }

  descargar() {
    // console.log(this.arrAgentes);
    this.serviceWa.exportAsExcelFile(this.arrAgentes, `Reporte-Productividad-Agentes${this.formatdate.transform(new Date(),
      'dd-MM-yyyy-HH-mm-ss')}`);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner:'dots',
      //message: mensaje,
      cssClass:'loaderGeneral',
      message:'<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>'
    });
  await this.loading.present();
}

getToday() {
  const dateIn = new Date();
  const datefin = new Date();
  dateIn.toUTCString();
    datefin.toUTCString();

    dateIn.setHours(0, 0, 0);
    datefin.setHours(23, 59, 59);

  this.inicio = dateIn.toJSON();
  this.fin = datefin.toJSON();
  this.getPromedioConver();
}

busqueda(ev) {
   this.nombreAgente = ev.detail.value;
}

getPromedioConver() {

  if(this.fechaFinal.value && this.fechaInicial.value) {
    let feIn = new Date(this.fechaInicial.value);
    let feFin = new Date(this.fechaFinal.value);

    feIn.toUTCString();
    feFin.toUTCString();
    const dayIn = feIn.getUTCDate();
    const dayFin = feFin.getUTCDate();

      feIn.setUTCDate(dayIn + 1);
      feFin.setUTCDate(dayFin + 1);

    feIn.setHours(0, 0, 0);
    feFin.setHours(23, 59, 59);

    this.inicio = feIn;
    this.fin = feFin;
  }

  let query = `inicio=${this.inicio}&fin=${this.fin}`;
  
  this.serviceWa.getPromedioConver(query, this.idAdmin, this.classUser.id, this.classUser.rol,
    this.classUser.token, this.classUser.canale.url_back).subscribe(
    (res: any)=>{
    // console.log(res);
    // this.loading.dismiss();

      const {status} = res;
      if(status =='success'){
       const {agentes} = res;
       this.agentes = agentes;
      //  console.log(this.sesiones);
       this.presentToast('Datos encontrados!', 'success');
      }
      else{
       this.presentToast('No se encontrarón Agentes', 'danger');
      }
  },
  erro => {
    console.log(erro);
    this.loading.dismiss();
  });
}
  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

}
